module.exports = __webpack_public_path__ + "static/media/frame.f2ee7bd0.png";